module.exports = __webpack_public_path__ + "img/bullseye.4bbdead9.svg";